module.exports = __webpack_public_path__ + "img/shop.be5ce780.jpg";